import React, { useMemo } from "react";
import _Input from "../../generic/_Input";
import _Select from "../../generic/_Select";
import { useFormikContext } from "formik";
import TotalAudience from "../TotalAudience";
import { Tooltip } from "../../../components/ui/Tooltip";
const GeneralData = () => {
  const { values, handleChange, errors, handleBlur } = useFormikContext();
  const { listDatabases = [], campaignName, uiddatabase, ttl } = values;

  const databases = useMemo(() => {
    const isArray = Array.isArray(listDatabases);
    return isArray ? listDatabases : [];
  }, [listDatabases]);

  return (
    <div className="bg-white !px-4 !py-2 rounded-lg">
      <div className="text-xl font-bold text-gray-600">Datos Generales</div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col py-2">
          <_Input
            title="Nombre de la Campaña"
            name="campaignName"
            id="campaignName"
            type="text"
            value={campaignName}
            onChange={handleChange}
            placeholder="Ejemplo: Promoción de Verano"
            onBlur={handleBlur}
            errors={errors && errors.campaignName}
            isError={errors && errors.campaignName ? true : false}
            required
          />
        </div>

        <div className="flex flex-col py-2">
          <_Select
            title="Base de Datos"
            required
            name="uiddatabase"
            id="uiddatabase"
            value={uiddatabase}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors && errors.uiddatabase}
            isError={errors && errors.uiddatabase ? true : false}
            options={[
              {
                value: "",
                label: "Selecciona de la lista",
              },
              ...databases.map((item) => ({
                value: item.uiddatabase,
                label: item.name,
              })),
            ]}
          />
        </div>
      </div>

      <div className="w-full py-2 ">
        <div className="flex justify-between">
          <span className="text-[14px] font-semibold flex justify-center gap-2 items-center text-gray-600 rounded-lg">
            Tiempo de Vida del Mensaje (TTL)
          </span>
          <Tooltip message="El TTL es el tiempo de vida del mensaje en donde se considerará válido y entregable. Si el mensaje no se entrega correctamente al dispositivo del usuario dentro de este período, se intenta revocarlo automáticamente">
            <span className="material-icons-outlined cursor-pointer">info</span>
          </Tooltip>
        </div>
        <_Select
          name="ttl"
          id="ttl"
          value={ttl}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors && errors.ttl}
          isError={errors && errors.ttl ? true : false}
          options={[
            {
              vale: "60s",
              label: "Predeterminado (1 minuto)",
            },
            {
              value: "600s",
              label: "10 minutos",
            },
            {
              value: "3600s",
              label: "1 hora",
            },
            {
              value: "86400s",
              label: "24 horas",
            },
            {
              value: "1296000s",
              label: "Máximo (15 días)",
            },
          ]}
        />
      </div>
      <TotalAudience />
    </div>
  );
};

export default GeneralData;
